import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Header = ({ activeSection, handleNavClick }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md">
      <motion.div 
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ type: 'spring', stiffness: 100 }}
        className="container mx-auto px-6 py-4 flex justify-between items-center"
      >
        <motion.div 
          className="flex items-center space-x-2"
          whileHover={{ scale: 1.05 }}
          transition={{ type: 'spring', stiffness: 400, damping: 10 }}
        >
          <img 
            alt="Memic Logo" 
            className="h-14 w-30" 
            src="/images/memic_logo_3.png" 
          />
        </motion.div>
        <nav className="space-x-6">
          {[
            { name: 'Home', id: 'home' },
            { name: 'Features', id: 'features' },
            { name: 'How it Works', id: 'how-it-works' }
          ].map((item, index) => (
            <motion.a 
              key={item.id}
              initial={{ opacity: 0 }}
              animate={{ 
                opacity: 1,
                color: activeSection === item.id ? '#ffffff' : '#9ca3af'
              }}
              transition={{ delay: index * 0.1 }}
              className={`hover:text-white transition-colors ${activeSection === item.id ? 'text-white' : 'text-gray-300'}`}
              href={`#${item.id === 'home' ? 'hero' : item.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.id);
              }}
            >
              {item.name}
            </motion.a>
          ))}
        </nav>
      </motion.div>
    </header>
  );
};

export default Header; 